import { AnswerType } from '@asset/enum/problemSolvingEnum';
import { MediaType } from '@asset/type/common/type';

export interface CommonResponse {
  success: boolean;
}

export interface MaterialClassification {
  chapterIdx?: number;
  chapterName?: string;
  sectionIdx?: number;
  sectionName?: string;
  subsectionIdx?: number;
  subsectionName?: string;
  problemTypeIdx?: number;
  problemTypeName?: string;
  indexNumber?: number;
  indexName?: string;
  division?: string;
  subIndexNumber?: number;
}

export interface AnswerInfo {
  json: object;
  type: AnswerType;
}

export interface MediaContent {
  mediaType: MediaContentMediaType;
  url: string;
}

export enum MediaContentMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export const mediaContentMediaTypeToMediaType = (
  mediaContentMediaType: MediaContentMediaType,
): MediaType => {
  if (mediaContentMediaType === MediaContentMediaType.VIDEO) {
    return MediaType.VIDEO;
  }
  return MediaType.IMG;
};
